(function(window, quizServiceDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.quizService = quizServiceDefinition(
      window.$,
      window.Q,
      namespace.HttpService,
      namespace.log,
      namespace.quizDataXmlConverter,
      namespace.BackoffStrategyFactory,
      namespace.tokenService);
})(this, function($, Q, HttpService, log, quizDataXmlConverter, BackoffStrategyFactory, tokenService) {
   'use strict';

   var _definitionEndPoint = 'v/1/quiz/definition';
   var _instanceEndPoint = 'v/1/quiz/instance?noop=1';
   var _responseEndPoint = 'v/1/quiz/response?noop=1';
   var _progressEndPoint = 'v/1/quiz/progress?noop=1';

   var _environments = [
      {label: 'Local', url: 'https://quiz.techsmith.localhost:11443/'},
      {label: 'Dev', url: 'https://quiz.cloud.tsc-dev.co/'},
      {label: 'Stage', url: 'https://quiz.cloud.tsc-stage.co/'},
      {label: 'Live', url: 'https://quiz.cloud.techsmith.com/'},
      {label: 'TE', url: 'https://quizzingtest2.cloud.tsc-dev.co/'}
   ];

   var _environmentId = 3;
   var _quizInstanceDataDefer = Q.defer();
   var httpService = HttpService.create();
   var httpServiceWithUnlimitedRetries = HttpService.create(BackoffStrategyFactory.createWithUnlimitedRetries());
   var httpServiceWithNoLogging = HttpService.create(BackoffStrategyFactory.create(), false);

   //should only be used for the purposes of unit tests!
   var reset = function() {
      httpServiceWithUnlimitedRetries = HttpService.create(BackoffStrategyFactory.createWithUnlimitedRetries());
      httpService = HttpService.create();
      httpServiceWithNoLogging = HttpService.create(BackoffStrategyFactory.create(), false);
      _quizInstanceDataDefer = Q.defer();
   };

   var submitQuizDefinition = function(quizJsonData, hash, clientId) {
      if (!quizJsonData) {
         return Q();
      }

      if (typeof quizJsonData === 'string') {
         quizJsonData = $.parseJSON(quizJsonData);
      }

      var quizDefinitionXml = quizDataXmlConverter.quizDefinitionToXml(quizJsonData);
      var url = _environments[_environmentId].url + _definitionEndPoint + '?Quiz-Checksum=' + hash + '&Quiz-ClientId=' + clientId + '&noop=1';
      var data = {DefinitionText: quizDefinitionXml};

      return httpService.sendFormDataPost(url, data).then(function() {
         return quizDefinitionXml;
      });
   };
   
   var getInstanceFormData = function(quizModel, firstName, lastName, email, playerConfiguration) {
      var data = {
         QuizId: quizModel.quizID,
         CheckForQuizDefinition: playerConfiguration.getFathomId() === undefined
      };

      if (playerConfiguration.getTechSmithAccessTokenEndpoint()) {
         return tokenService.getTechSmithAccessToken(playerConfiguration).then(function(token) {
            data.AccessToken = token;
            return data;
         });
      }
      
      data.FirstName = !firstName ? '' : firstName;
      data.LastName = !lastName ? '' : lastName;
      data.Email = !email ? '' : email;
      return Q(data);
   };

   var startQuizInstance = function(quizModel, firstName, lastName, email, playerConfiguration) {
      var url = _environments[_environmentId].url + _instanceEndPoint;

      getInstanceFormData(quizModel, firstName, lastName, email, playerConfiguration).then(function(data) {
         httpService.sendFormDataPost(url, data).then(function(response) {
            if (response.DefinitionRequired) {
               return submitQuizDefinition(quizModel.quizDefinition, quizModel.quizHash, quizModel.clientId).then(function() {
                  return response;
               });
            }
            return response;
         }).then(function(response) {
            _quizInstanceDataDefer.resolve({
               analyticsSampleRate: response.SampleRate,
               quizInstanceId: response.Id
            });
         }).catch(_quizInstanceDataDefer.reject);
      });

      return _quizInstanceDataDefer.promise;
   };
   
   var sendProgress = function(sampleRateInMilliseconds, completedSamples) {
      if (completedSamples && completedSamples.length > 0) {
         return _quizInstanceDataDefer.promise.then(function(quizInstanceData) {
            var url = _environments[_environmentId].url + _progressEndPoint;
            var data = {
               InstanceId: quizInstanceData.quizInstanceId,
               Interval: sampleRateInMilliseconds,
               ViewedSegments: completedSamples
            };

            return httpServiceWithNoLogging.sendFormDataPost(url, data, 0);
         });
      }
   };

   var setEnvironment = function(environmentId) {
      _environmentId = environmentId;
   };

   var getEnvironment = function() {
      return _environmentId;
   };

   var submitQuestionSet = function(questionSetData) {
      return _quizInstanceDataDefer.promise.then(function(quizInstanceData) {
         if (!quizInstanceData.quizInstanceId) {
            return Q.reject('No quiz instance ID found');
         }

         if (typeof questionSetData === 'string') {
            questionSetData = $.parseJSON(questionSetData);
         }

         var questionSetXml = quizDataXmlConverter.questionSetToXml(questionSetData, quizInstanceData.quizInstanceId);
         var url = _environments[_environmentId].url + _responseEndPoint;
         var data = {
            ResponseText: questionSetXml
         };

         return httpServiceWithUnlimitedRetries.sendFormDataPost(url, data).then(function(response) {
            return response.results;
         });
      });
   };

   var getAnalyticsRate = function() {
      return _quizInstanceDataDefer.promise.then(function(response) {
         return response.analyticsSampleRate;
      });
   };

   return {
      setEnvironment: setEnvironment,
      getEnvironment: getEnvironment,
      startQuizInstance: startQuizInstance,
      submitQuestionSet: submitQuestionSet,
      sendProgress: sendProgress,
      getAnalyticsRate: getAnalyticsRate,
      reset: reset
   };
});
